import React from 'react';
import styled from 'styled-components';
import { ChangeLogTable } from 'components';
import { ITipCalculatorChangeLogEntry } from 'types';
import { IExportData } from './types';

const Layout = styled.section`
  width: 100%;
`;

interface IChangeLogProps {
  header: (data?: IExportData) => React.ReactNode;
  changeLogEntries?: ITipCalculatorChangeLogEntry[];
  isLoading?: boolean;
}

const ChangeLog = ({ header, changeLogEntries, isLoading }: IChangeLogProps) => (
  <>
    {header()}
    <Layout>{!isLoading && <ChangeLogTable changeLogEntries={changeLogEntries || []} />}</Layout>
  </>
);

export default ChangeLog;
